import { makeStyles } from '@material-ui/core';
import { rem, vh, vw } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';

export const styles = makeStyles(theme => ({
  dialogPaper: {
    minHeight: '96vh',
    maxHeight: '96vh',
    minWidth: '97.5vw',
    maxWidth: '97.5vw',
    borderRadius: 'unset',
    backgroundColor: themeColor.lightBackground,
  },
  contentContainer: {
    padding: '2.34vh 1.47vw 0 1.47vw',
    '& button': {
      fontSize: rem(1),
      letterSpacing: '0.4px',
    },
    '& label': {
      fontSize: rem(1.25),
      order: -1,
    },
    '& input': {
      fontSize: rem(1.25),
      color: themeColor.defaultTextColor,
      fontWeight: 500,
    },
  },
  inputGrid: {
    marginTop: '10px',
  },
  titleContainer: {
    height: '14.77vh',
    width: '100%',
  },
  container: {
    textAlign: 'center',
    background: themeColor.white,
    border: `1px solid ${themeColor.secondaryLight}`,
  },
  contentTitle: {
    height: '3.39vh',
    fontSize: rem(1.25),
    fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
    fontWeight: 500,
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: '1px',
    color: themeColor.defaultTextColor,
    alignSelf: 'flex-start',
    marginLeft: '1.53vw',
    marginTop: '3.78vh',
  },
  searchContainer: {
    minHeight: '32.72vh',
    overflowY: 'hidden',
  },
  gap10: {
    gap: '10px',
  },
  closeButton: {
    color: themeColor.defaultTextColor,
    minWidth: vw(7.6135),
  },
  searchButton: {
    '&:disabled': {
      color: themeColor.rollingStone,
      background: themeColor.progressBar,
      opacity: '1',
      '& span': {
        opacity: 1,
      },
    },
    minWidth: vw(7.32),
  },
  inputTextField: {
    '& .MuiOutlinedInput-root': {
      width: '32.85vw',
      height: '7.29vh',
    },
    height: '10.8vh',
    '& div': {
      paddingRight: '0px',
    },
  },
  errorMessage: {
    fontSize: vh(2.08),
    color: theme.palette.info.dark,
    fontWeight: 500,
    letterSpacing: '0.1vw',
    fontStretch: 'normal',
    fontStyle: 'normal',
    textTransform: 'uppercase',
  },
  icon: {
    display: 'inline-block',
    height: '2.8vh',
    width: '2.3vw',
    color: themeColor.alert,
  },
  form: {
    marginTop: '7.806vh',
  },
  formFieldsWrapper: {
    width: '32.94vw',
    '& .formInputHeight': {
      height: '10vh',
      '@media (max-width: 1024px) and (max-height: 576px)': {
        height: '13vh',
      },
    },
  },
  formCenterOr: {
    width: '16.47vw',
    textAlign: 'center',
    fontSize: rem(1.125),
    color: themeColor.defaultTextColor,
    fontWeight: 500,
  },
  formError: {
    height: '2.87vh',
  },
  trainingModeBackground: {
    minHeight: '96vh',
    maxHeight: '96vh',
    minWidth: '97.5vw',
    maxWidth: '97.5vw',
    borderRadius: 'unset',
    backgroundColor: themeColor.trainingBackground,
  },
  looksDisabled: {
    '& label': {
      color: themeColor.subtleDisabledTextGrey,
    },
  },
  helper: {
    fontSize: rem(0.875),
  },
}));
